module.exports = __webpack_public_path__ + "img/wechat.473ac8b7.png";